import { logToDataLayer } from './LogHelper';

export const logSearch = (loggingData, translatedMessage) => {
  let error = '';
  if (translatedMessage && translatedMessage.severity !== 'information') {
    error = `${translatedMessage?.errorCode}:${translatedMessage?.program}:${translatedMessage?.systemId}`;
  }

  if (loggingData) {
    logToDataLayer({
      event: loggingData.event,
      travelAdults: loggingData.numberOfAdults,
      travelChildren: loggingData.numberOfChildren,
      travelPax: loggingData.numberOfPassengers,
      travelAges: loggingData.passengerAges,
      travelHits: loggingData.numberOfHits,
      travelType: loggingData.travelType,
      travelDepartureDay: loggingData.departureDateDay,
      travelDepartureMonth: loggingData.departureDateMonth,
      travelDepartureYear: loggingData.departureDateYear,
      travelDuration: loggingData.duration,
      travelDepartureCode: loggingData.departureCode,
      travelDestinationCode: loggingData.destinationCode,
      travelAction: loggingData.action,
      travelCruiseArea: loggingData.areaWvId,
      ...(error && { error }),
    });

    if (error) {
      logToDataLayer({
        error,
        event: 'CA error',
      });
    }
  }
};

// Builds and returns the product impression
export const getProductImpression = (packageData, position) => {
  return {
    name: packageData?.tripRuleName,
    id: packageData?.tdmRuleId,
    price: packageData?.totalPriceRounded,
    brand: packageData?.cruise?.cruiseCompanyName,
    category: 'CruisePackage',
    variant: 'VITS',
    list: 'CruisePackage Search Results',
    position,
  };
};

// Logs product impressions
export const logProductImpression = (packageList) => {
  logToDataLayer({
    event: 'productImpression',
    ecommerce: {
      impressions: packageList.map((packageData, index) => {
        return getProductImpression(packageData, index + 1);
      }),
    },
  });
};

export const logProductClick = (loggingData) => {
  const { list, ...rest } = loggingData;
  logToDataLayer({
    event: 'productClick',
    ecommerce: {
      click: {
        actionField: {
          list: 'CruisePackage Search Results',
          action: 'click',
        },
        products: [{ ...rest }],
      },
    },
  });
};
